export default "__VITE_ASSET__B4yAm6GX__";